'use client';

import React from 'react';
import { Card, EmptyState } from '@shopify/polaris';
import FacebookInstagramIcon from '@/public/assets/media-provider-icons/facebookInstagram.svg';
import TikTokIcon from '@/public/assets/media-provider-icons/tiktok.svg';
import TolstoyIcon from '@/public/assets/media-provider-icons/tolstoy.svg';
import { MediaAssetProviders } from '@/features/ai-video-creator/stores/productMediaSlice';

const PROVIDER_ICONS = {
  default: TolstoyIcon,
  [MediaAssetProviders.instagram]: FacebookInstagramIcon,
  [MediaAssetProviders.tiktok]: TikTokIcon,
};

export type NoContentButtonProps = {
  provider: MediaAssetProviders;
  onAction?: () => void;
  actionText?: string;
  actionLabel?: string;
  emptyStateHeading?: string;
};

export const NoContentButton = ({
  provider,
  onAction,
  actionText = 'Connect sources with Tolstoy to add content to this section.',
  actionLabel = 'Connect with Tolstoy',
  emptyStateHeading = 'No content available',
}: NoContentButtonProps) => {
  const providerIcon = PROVIDER_ICONS[provider] || '';

  return (
    <Card>
      <EmptyState
        heading={emptyStateHeading}
        image={providerIcon.src}
        action={{
          content: actionLabel,
          onAction,
        }}
      >
        <p>{actionText}</p>
      </EmptyState>
    </Card>
  );
};
